import Viewer from './Viewer.js';

let activeViewer = null;

window.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);

  const mainContainer = document.querySelector('#main-container');
  const projects = mainContainer.querySelectorAll('.list__item');
  const descriptions = document.querySelectorAll('.desc__item');
  const viewer = document.querySelector('.viewer');
  const infoPanel = document.querySelector('.info-panel');

  header.addEventListener('click', () => {
    infoPanel.classList.toggle('is-open');
  });

  projects.forEach(item => {
    item.addEventListener('click', () => {
      const key = item.dataset.key;
      const isAlreadyActive = item.classList.contains('is-active');

      projects.forEach(p => p.classList.remove('is-active'));
      descriptions.forEach(d => d.classList.remove('is-active'));
      if (activeViewer) {
        activeViewer.destroy();
        activeViewer = null;
      }

      if (!isAlreadyActive) {
        item.classList.add('is-active');
        document.querySelector(`.desc__item[data-key="${key}"]`).classList.add('is-active');

        const data = JSON.parse(item.querySelector('script[type="application/json"]').textContent);
        activeViewer = new Viewer(viewer, {
          prev: '.viewer__prev',
          next: '.viewer__next'
        }).init(data);
      }
    });
  });
});

